
<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-search-input
              v-model="filter.name"
              width="140px"
              placeholder="物流商编码/名称"
            >
          </gj-search-input>
          <gj-select
              v-model="filter.state"
              :options="option.state"
              placeholder="状态"
          ></gj-select>
          <gj-creator-select
              v-model="filter.logisticsUserId"
              placeholder="物流员"
          ></gj-creator-select>
          <gj-date-picker
              v-model="filter.date"
              type="daterange"
          ></gj-date-picker>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            v-if="$permission('logistics:add')"
            type="primary"
            @click="add(), userGuideTemporarilyClosed()">
          添加
        </gj-button>
        <gj-button
            v-if="$permission('logistics:add')"
            @click="importItem()">
          导入
        </gj-button>
        <gj-button
            v-if="$permission('logistics:enable')"
            :disabled="noSelect || selectedSomeIs('status', LogisticsProviderEnum.status.ENABLE)"
            @click="active(selectedRows)">
          启用
        </gj-button>
        <gj-button
            v-if="$permission('logistics:enable')"
            :disabled="noSelect || selectedSomeIs('status', LogisticsProviderEnum.status.DISABLE)"
            @click="inactive(selectedRows)">
          停用
        </gj-button>
        <gj-button
            v-if="$permission('logistics:delete')"
            :disabled="noSelect"
            @click="deleteItem(selectedRows)">
          删除
        </gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            :download="$permission('logistics:export')" download-url="/supply/logistics/export" :download-params="globalParams"
            help
            setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :name="tableName"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            selection
            sortable="custom"
            :pagination="pagination"
            :default-sort="{prop: 'createTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:op="{ row }">
            <gj-button-group
                type="dropdown-op"
                :config="opBtnConfig(row)"
            ></gj-button-group>
          </template>
        </gj-table>
      </template>
      <template v-if="userGuideState" #base-content>
        <new-user-guide ref="newUserGuide" ></new-user-guide>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin, selectionMixin, userGuideMixin} from "../../../../minxins";
  import NewUserGuide from "./components/new-user-guide"
  import AppImportLogisticsProviderModal from "./modal/import-logistics-provider-modal";
  import AppOpLogisticsProviderModal from "./modal/op-logistics-provider-modal";
  import {OpEnum} from "../../../../utils/options";
  import {LogisticsProviderEnum} from "./enum";
  import {
    deleteLogisticsProvider,
    disableLogisticsProvider,
    enableLogisticsProvider,
    getLogisticsPage
  } from "../../../../api/logistics";
  import {defaultVal} from "../../../../utils/common";
  import {convertToDate} from "../../../../utils/date.util";
  import {
    LOGISTICS_GET_ACTIVE_LOGISTICS_OPTIONS, LOGISTICS_GET_LOGISTICS_OPTIONS,
  } from "../../../../store/action-types";

  export default {
    name: "app-logistics-provider",
    mixins: [queryMixin, selectionMixin, responseMixin, userGuideMixin],
    components: { NewUserGuide },
    data() {
      return {
        tableName: 'logisticsProvider',
        tableData: [],
        columns: [
          {id: 'code', header: '物流商编号', field: 'code', minWidth: '150px', disabled: true, default: true},
          {id: 'name', header: '物流商名称', field: 'name', minWidth: '150px', disabled: true, default: true},
          {id: 'status', header: '状态', field: 'option(plain):status', options: LogisticsProviderEnum.statusOption, minWidth: '80px', default: true},
          {id: 'logisticsUser', header: '物流员', field: 'logisticsUser', minWidth: '120px', default: true},
          {id: 'contact', header: '联系人', field: 'contact', minWidth: '120px', default: true},
          {id: 'contactPhone', header: '联系电话', field: 'contactPhone', minWidth: '120px', default: true},
          {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '120px', default: true},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '150px', default: true},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right', notCustomColumn: true}
        ],
        opBtnConfig: (row) => [
          {
            label: '编辑',
            show: () => this.$permission('logistics:add'),
            click: () => this.edit(row)
          },
          {
            label: '启用',
            show: () => this.$permission('logistics:enable')
              && row.status === LogisticsProviderEnum.status.DISABLE,
            click: () => this.active([row])
          },
          {
            label: '停用',
            show: () => this.$permission('logistics:enable')
              && row.status === LogisticsProviderEnum.status.ENABLE,
            click: () => this.inactive([row])
          },
          {
            label: '删除',
            show: () => this.$permission('logistics:delete'),
            click: () => this.deleteItem([row])
          },
          {
            label: '日志',
            click: () => this.viewLog(row)
          },
        ],
        filter: {},
        option: {
          state: LogisticsProviderEnum.statusOption
        },
        LogisticsProviderEnum: LogisticsProviderEnum
      }
    },
    created() {
      this.sort.prop = 'createTime';
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            logisticsId: null,
            logisticsUserId: null,
            date: null
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            id: defaultVal(this.filter.logisticsId),
            name: defaultVal(this.filter.name),
            status: defaultVal(this.filter.state),
            startCreateTime: this.filter.date ? convertToDate(this.filter.date[0]) : null,
            endCreateTime: this.filter.date ? convertToDate(this.filter.date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getLogisticsPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      add() {
        this.addModal = this.$gjCreate(AppOpLogisticsProviderModal, {
          props: {
            opType: OpEnum.type.ADD,
          },
          on: {
            created: () => {
              this.refreshStoreLogistics();
              this.$gjResetPage();
              if(this.userGuideState) {
                this.isNoAutoAddModal = true // 手动销毁弹框
                this.userGuideNextStep(2)
              }
              this.addModal.$gjDestroy();
            },
            close: () => {
              this.addModal = null
              if(!this.isNoAutoAddModal) {
                this.userGuideCancel()
                this.isNoAutoAddModal = false
              }
            }
          }
        })
      },
      view(row) {
        this.$gjCreate(AppOpLogisticsProviderModal, {
          props: {
            opType: OpEnum.type.VIEW,
            item: row
          }
        })
      },
      edit(row) {
        this.$gjCreate(AppOpLogisticsProviderModal, {
          props: {
            opType: OpEnum.type.UPDATE,
            item: row
          },
          on: {
            updated: () => {
              this.refreshStoreLogistics();
              this.$gjResetPage();
            }
          }
        })
      },
      active(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '启用确认',
            content: rows.length === 1 ? `确定要启用物流商[${rows[0].name}]吗？` : `已选中 ${rows.length} 个物流商，确定要批量启用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              enableLogisticsProvider(rows.map(e => e.id))
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.refreshStoreLogistics();
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      deleteItem(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: rows.length === 1
              ? `确定要删除物流商[${rows[0].name}]吗？一旦删除不可恢复，请谨慎操作！`
              : `已选中 ${rows.length} 个物流商，确定要批量删除吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteLogisticsProvider(rows.map(e => e.id))
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.refreshStoreLogistics();
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      inactive(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '停用确认',
            content: rows.length === 1 ? `确定要停用物流商[${rows[0].name}]吗？` : `已选中 ${rows.length} 个物流商，确定要批量停用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              disableLogisticsProvider(rows.map(e => e.id))
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.refreshStoreLogistics();
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      importItem() {
        this.$gjCreate(AppImportLogisticsProviderModal, {
          on: {
            importFileSuccess: () => {
              this.refreshStoreLogistics();
              this.$gjResetPage();
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '/supply/logistics/log/page',
            params: {
              model: row.id
            },
          }
        });
      },
      refreshStoreLogistics() {
        this.$store.dispatch(LOGISTICS_GET_ACTIVE_LOGISTICS_OPTIONS);
        this.$store.dispatch(LOGISTICS_GET_LOGISTICS_OPTIONS);
      },
    }
  }
</script>

<style scoped>

</style>
